import { useMutation } from '@apollo/client';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useToast } from '../../toast/Toast.context';
import {
  STAFF_JOIN_CARPOOL_TRIP,
  StaffJoinCarpoolTripMutation,
  StaffJoinCarpoolTripMutationVariables,
} from '../graphql/mutation/staffJoinCarpoolTripMutation.graphql';
import {
  CARPOOL_TRIPS,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useStaffJoinCarpoolTripMutation = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const { showToast } = useToast();
  const [mutate] = useMutation<
    StaffJoinCarpoolTripMutation,
    StaffJoinCarpoolTripMutationVariables
  >(STAFF_JOIN_CARPOOL_TRIP);

  const staffJoinCarpoolTrip = async (tripId: string, userId: string) => {
    const eventId = currentEventData?.currentEvent?.id;
    if (!eventId) {
      return;
    }

    await mutate({
      variables: { tripId, userId },
      refetchQueries: [
        {
          query: CARPOOL_TRIPS,
          variables: { eventId } satisfies CarpoolTripsQueryVariables,
        },
      ],
    });

    showToast({
      type: 'success',
      message: 'Passager ajouté.',
    });
  };

  return { staffJoinCarpoolTrip };
};
